import { Selector } from "antd-mobile";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";
import "./style.scss";

const FilterTypeSelect = ({
  required = false,
  title = "",
  options = [],
  value = [],
  columns = 3,
  setValue = () => {},
}) => {
  const { t } = useTranslation();
  const onSelectChange = (value) => {
    if (value.length) {
      setValue(value[0]);
    } else {
      if (required === false) {
        setValue(null);
      }
    }
  };

  return (
    <div className={`${styles.container} filter-select`}>
      <div className={`${styles.title}`}>{title}</div>
      <Selector
        className={`custom-selector`}
        options={options}
        columns={columns}
        value={value}
        onChange={onSelectChange}
      />
    </div>
  );
};

export default FilterTypeSelect;
